var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiGetListClientRfpNegotiate } from '@/actions/ClientRfpNegotiateActions/getList';
import { apiGetOneClientNegotiate } from '@/actions/ClientRfpNegotiateActions/getOne';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * データの取得, ローディング制御
 */
export const useRfpClientOneNegotiateFetch = (args) => {
    const { id } = args;
    const [selectedId, setSelectedId] = useState(null);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    // 一覧データ 取得
    const negotiateList = useTypeSelector((state) => { var _a; return ((_a = state.clientRfpNegotiateList.one[id]) === null || _a === void 0 ? void 0 : _a.list) || []; });
    // 詳細データ 取得
    const negotiateOne = useTypeSelector((state) => {
        var _a;
        return selectedId !== null
            ? ((_a = state.clientRfpNegotiateOne.one[id]) === null || _a === void 0 ? void 0 : _a[selectedId]) || {}
            : {};
    });
    /**
     * 条件相談データ 取得（ローディング有）
     */
    const fetchNegotiate = useCallback(({ rfpId, viewRequestId }) => __awaiter(void 0, void 0, void 0, function* () {
        if (viewRequestId === null) {
            return;
        }
        yield wrapDispatch(dispatch, apiGetOneClientNegotiate({ path: { id: rfpId, view_request_id: viewRequestId } }, {}));
    }), [dispatch]);
    /**
     * 条件相談詳細 取得
     */
    const { callbackPromiseEvent: fetchNegotiateOne, doing: loadingOfGetOne } = usePromiseDoingCallback({
        promiseEvent: fetchNegotiate,
        unmountRef,
    });
    /**
     * 条件相談メッセージ一覧 取得
     */
    const fetchNegotiateList = useCallback(({ rfpId, selectedViewRequestId }) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const res = yield wrapDispatch(dispatch, apiGetListClientRfpNegotiate({ path: { id: rfpId } }, {}));
        const viewRequestId = selectedViewRequestId === null
            ? ((_b = (_a = res.payload.list[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null)
            : selectedViewRequestId;
        setSelectedId(viewRequestId);
        yield fetchNegotiate({
            rfpId,
            viewRequestId,
        });
    }), [dispatch, fetchNegotiate]);
    /**
     * 条件相談データ 取得（ローディング有）
     */
    const { callbackPromiseEvent: fetchNegotiateListHasLoading, doing: loadingOfGetList, } = usePromiseDoingCallback({
        promiseEvent: fetchNegotiateList,
        unmountRef,
    });
    /**
     * 一覧クリック時のイベント: 詳細表示データの変更
     */
    const onClickItem = useCallback((viewRequestId) => {
        if (viewRequestId !== selectedId) {
            setSelectedId(viewRequestId);
            fetchNegotiateOne({ rfpId: id, viewRequestId });
        }
    }, [selectedId, fetchNegotiateOne, id]);
    // 初回 データ取得
    useEffect(() => {
        fetchNegotiateListHasLoading({ rfpId: id, selectedViewRequestId: null });
    }, [fetchNegotiateListHasLoading, id]);
    return {
        fetchNegotiateList,
        loadingOfGetList,
        loadingOfGetOne,
        negotiateList,
        negotiateOne,
        onClickItem,
        selectedId,
    };
};
